import React, { Component } from 'react';
import AnimationInspector from './AnimationInspector';

export default class CompareVersion extends Component {
  constructor(props) {
    super(props);
    const { animation_first_id, animation_last_id } = props;
    this.state = {
      isRefresh: false,
      animationFirstId: animation_first_id,
      animationLastId: animation_last_id,
      seekTimeForSecondVersion: null,
      seekTimeForFirstVersion: null,
      firstVideoDuration: null,
      secondVideoDuration: null,
    };
    this.firstAnimationInspectorRef = React.createRef();
    this.secondAnimationInspectorRef = React.createRef();
  }

  reFreshNow = () => {
    this.setState({ isRefresh: !this.state.isRefresh });
  }

  setAnimationIdWhenChange = (animationId, AnimationNo) => {
    if(AnimationNo === 'firstAnimation') {
      this.setState({ animationFirstId: animationId });
    } else if(AnimationNo === 'lastAnimation') {
      this.setState({ animationLastId: animationId });
    }
  }

  handleSeekedSecond = () => {
    this.setState({ seekTimeForSecondVersion: null });
  }

  handleSeekedFirst = () => {
    this.setState({ seekTimeForFirstVersion: null });
  }

  // New handlers for video click synchronization
  handleVideoClickedFirst = (currentTime, firstDuration) => {
    // Store first video duration for future reference
    this.setState({ firstVideoDuration: firstDuration });

    // Pause the second video
    if (this.secondAnimationInspectorRef.current && this.secondAnimationInspectorRef.current.animationPlayer) {
      if (this.secondAnimationInspectorRef.current.animationPlayer.pauseVideo) {
        // For YouTube videos (ShowEmbedVideo)
        this.secondAnimationInspectorRef.current.animationPlayer.pauseVideo();
      } else if (this.secondAnimationInspectorRef.current.animationPlayer.player) {
        // For regular videos (AnimationPlayer)
        this.secondAnimationInspectorRef.current.animationPlayer.player.pause();
      }
    }

    // When first video is clicked, synchronize second video
    // If second video is shorter, seek to its maximum duration
    const { secondVideoDuration } = this.state;
    const seekTime = secondVideoDuration ? Math.min(currentTime, secondVideoDuration) : currentTime;
    this.setState({ seekTimeForSecondVersion: seekTime });
  }

  handleVideoClickedSecond = (currentTime, secondDuration) => {
    // Store second video duration for future reference
    this.setState({ secondVideoDuration: secondDuration });

    // Pause the first video
    if (this.firstAnimationInspectorRef.current && this.firstAnimationInspectorRef.current.animationPlayer) {
      if (this.firstAnimationInspectorRef.current.animationPlayer.pauseVideo) {
        // For YouTube videos (ShowEmbedVideo)
        this.firstAnimationInspectorRef.current.animationPlayer.pauseVideo();
      } else if (this.firstAnimationInspectorRef.current.animationPlayer.player) {
        // For regular videos (AnimationPlayer)
        this.firstAnimationInspectorRef.current.animationPlayer.player.pause();
      }
    }

    // When second video is clicked, synchronize first video
    // If first video is shorter, seek to its maximum duration
    const { firstVideoDuration } = this.state;
    const seekTime = firstVideoDuration ? Math.min(currentTime, firstVideoDuration) : currentTime;
    this.setState({ seekTimeForFirstVersion: seekTime });
  }

  // New handlers for marker line click synchronization
  handleMarkerLineClickedFirst = (seekTime) => {
    // When marker in first video is clicked, synchronize second video
    // If second video is shorter, seek to its maximum duration
    const { secondVideoDuration } = this.state;
    const syncSeekTime = secondVideoDuration ? Math.min(seekTime, secondVideoDuration) : seekTime;
    this.setState({ seekTimeForSecondVersion: syncSeekTime });
  }

  handleMarkerLineClickedSecond = (seekTime) => {
    // When marker in second video is clicked, synchronize first video
    // If first video is shorter, seek to its maximum duration
    const { firstVideoDuration } = this.state;
    const syncSeekTime = firstVideoDuration ? Math.min(seekTime, firstVideoDuration) : seekTime;
    this.setState({ seekTimeForFirstVersion: syncSeekTime });
  }

  // New handlers for marker period synchronization
  handleMarkerPeriodChangedFirst = (seekTime) => {
    // When period marker in first video is changed, synchronize second video
    const { secondVideoDuration } = this.state;
    const syncSeekTime = secondVideoDuration ? Math.min(seekTime, secondVideoDuration) : seekTime;
    this.setState({ seekTimeForSecondVersion: syncSeekTime });
  }

  handleMarkerPeriodChangedSecond = (seekTime) => {
    // When period marker in second video is changed, synchronize first video
    const { firstVideoDuration } = this.state;
    const syncSeekTime = firstVideoDuration ? Math.min(seekTime, firstVideoDuration) : seekTime;
    this.setState({ seekTimeForFirstVersion: syncSeekTime });
  }

  render() {
    const { isRefresh, animationFirstId, animationLastId } = this.state;
    const {
      additional_info, akaire_file_id, avatar_url, baseURL, can_use_page_management, category,
      colors, company_id, complete_date, complete_updater_id, created_at, created_by, currentTicketId,
      current_limit_video, current_subscription_type, current_user_id, deleted_at, delivery_date, description,
      due_date, duplicate_completed, entity_id, entity_type, env, extensions, id, isAkaponProject, is_akapon_member,
      is_create_pass_video, is_create_video_embed, is_project_owner_member, member_setten, name, new_pic_ids,
      noti_compare_page, noti_compare_version, owner, page_last_animation, pass_word_share_url, password_share_akaire,
      pic_ids, port, priority_colors, project_id, project_type, public_history_chat, relationship, role,
      root_url, show_mode, start_date, status, token_public_url, total_file_size, updated_at, updated_by,
      url_token, windowHeight, windowWidth
    } = this.props;
    return (
      <div class='d-flex compare-version-screen'>
        <div class='col-6 first-version'>
          <AnimationInspector ref={this.firstAnimationInspectorRef} animation_id={animationFirstId}
            additional_info={additional_info} akaire_file_id={akaire_file_id} avatar_url={avatar_url} baseURL={baseURL}
            can_use_page_management={can_use_page_management} category={category} colors={colors}
            company_id={company_id} complete_date={complete_date} complete_updater_id={complete_updater_id}
            created_at={created_at} created_by={created_by} currentTicketId={currentTicketId}
            current_limit_video={current_limit_video} current_subscription_type={current_subscription_type}
            current_user_id={current_user_id} deleted_at={deleted_at} delivery_date={delivery_date}
            description={description} due_date={due_date} duplicate_completed={duplicate_completed}
            entity_id={entity_id} entity_type={entity_type} env={env} extensions={extensions} id={id}
            isAkaponProject={isAkaponProject} is_akapon_member={is_akapon_member}
            is_create_pass_video={is_create_pass_video} is_create_video_embed={is_create_video_embed}
            is_project_owner_member={is_project_owner_member} member_setten={member_setten} name={name}
            new_pic_ids={new_pic_ids} noti_compare_page={noti_compare_page} noti_compare_version={noti_compare_version}
            owner={owner} page_last_animation={page_last_animation} pass_word_share_url={pass_word_share_url}
            password_share_akaire={password_share_akaire} pic_ids={pic_ids} port={port} priority_colors={priority_colors}
            project_id={project_id} project_type={project_type} public_history_chat={public_history_chat}
            relationship={relationship} role={role} root_url={root_url} show_mode={show_mode} start_date={start_date}
            status={status} token_public_url={token_public_url} total_file_size={total_file_size} updated_at={updated_at}
            updated_by={updated_by} url_token={url_token} windowHeight={windowHeight} windowWidth={windowWidth}
            isRefresh={isRefresh} reFreshNow={this.reFreshNow} isFirstAnimation={true} setAnimationIdWhenChange={this.setAnimationIdWhenChange}
            seekTime={this.state.seekTimeForFirstVersion} onSeeked={this.handleSeekedFirst}
            onVideoClicked={this.handleVideoClickedFirst}
            onMarkerLineClicked={this.handleMarkerLineClickedFirst}
            onMarkerPeriodChanged={this.handleMarkerPeriodChangedFirst}
            commentPeriodContainer="comment-period-container-first"
          />
        </div>
        <div class='col-6 second-version'>
          <AnimationInspector ref={this.secondAnimationInspectorRef} animation_id={animationLastId}
            additional_info={additional_info} akaire_file_id={akaire_file_id} avatar_url={avatar_url} baseURL={baseURL}
            can_use_page_management={can_use_page_management} category={category} colors={colors}
            company_id={company_id} complete_date={complete_date} complete_updater_id={complete_updater_id}
            created_at={created_at} created_by={created_by} currentTicketId={currentTicketId}
            current_limit_video={current_limit_video} current_subscription_type={current_subscription_type}
            current_user_id={current_user_id} deleted_at={deleted_at} delivery_date={delivery_date}
            description={description} due_date={due_date} duplicate_completed={duplicate_completed}
            entity_id={entity_id} entity_type={entity_type} env={env} extensions={extensions} id={id}
            isAkaponProject={isAkaponProject} is_akapon_member={is_akapon_member}
            is_create_pass_video={is_create_pass_video} is_create_video_embed={is_create_video_embed}
            is_project_owner_member={is_project_owner_member} member_setten={member_setten} name={name}
            new_pic_ids={new_pic_ids} noti_compare_page={noti_compare_page} noti_compare_version={noti_compare_version}
            owner={owner} page_last_animation={page_last_animation} pass_word_share_url={pass_word_share_url}
            password_share_akaire={password_share_akaire} pic_ids={pic_ids} port={port} priority_colors={priority_colors}
            project_id={project_id} project_type={project_type} public_history_chat={public_history_chat}
            relationship={relationship} role={role} root_url={root_url} show_mode={show_mode} start_date={start_date}
            status={status} token_public_url={token_public_url} total_file_size={total_file_size} updated_at={updated_at}
            updated_by={updated_by} url_token={url_token} windowHeight={windowHeight} windowWidth={windowWidth}
            isRefresh={isRefresh} reFreshNow={this.reFreshNow} isLastAnimation={true} setAnimationIdWhenChange={this.setAnimationIdWhenChange}
            seekTime={this.state.seekTimeForSecondVersion} onSeeked={this.handleSeekedSecond}
            onVideoClicked={this.handleVideoClickedSecond}
            onMarkerLineClicked={this.handleMarkerLineClickedSecond}
            onMarkerPeriodChanged={this.handleMarkerPeriodChangedSecond}
            commentPeriodContainer="comment-period-container-second"
          />
        </div>
      </div>
    )
  }
}
